import { useEffect } from "react";
import { STAYS_EASE } from "../lib/motion";

/**
 * The page rules that hold only while a hub is in map view, on Stays and on
 * the activity hubs alike. Rendered inside the map column, so they exist only
 * while the map is on; the server-rendered page Google reads never has them.
 *
 *  - The list and the map reach past the page column (owner, 2026-09-28: "make
 *    it bigger, balanced with the cards"): up to 1600px wide, the map a little
 *    more than half.
 *  - The map pins under whatever is folded or unfolded above it. Set as the
 *    sticky offset, never as a transform: an offset only matters once the map
 *    is actually pinned, so near the top of the page, where it still sits in
 *    the flow beside the cards, it stays put. A transform shifted it there too
 *    and opened a wide empty band above it.
 *  - The footer and the hub's reading sections go: map view is the list and
 *    the map, nothing below them.
 *  - The map arrives with a short slide and fade; a plain fade for reduced motion.
 */
export function MapViewStyles() {
  // Tells the category rail the page is in map view (see useCompactOnScroll).
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.mapView = "";
    return () => {
      delete root.dataset.mapView;
    };
  }, []);
  return (
    <style>{`
      @media (min-width:1024px){
        /* Fills the window under the folded rail: pinned 12px below it, 12px
           short of the bottom edge. dvh is unzoomed and the page is at 90%,
           hence the division (the JS in StaysHubMap refines it on resize). */
        .mj-stays-map{height:calc(100dvh / var(--mj-ui-zoom, 1) - (var(--mj-hub-rail-h, 86px) - 46px + 12px) - 12px)}
        .mj-stays-map-pin{top:calc(var(--mj-hub-rail-h, 86px) - 46px + 12px)}
        html:not([data-hub-compact]) .mj-stays-map-pin{top:calc(var(--mj-header-h, 69px) + var(--mj-hub-rail-h, 86px) + 12px)}
        html[data-stays-bar] .mj-stays-map-pin{top:calc(var(--mj-hub-rail-h, 86px) - 46px + var(--mj-stays-bar-h, 56px) + 12px)}
        .mj-stays-split{margin-inline:calc(50% - min(800px, 50vw - 24px))}
      }
      .mj-site-footer,.mj-hub-extras{display:none}
      @keyframes mj-map-in{from{opacity:0;transform:translateX(24px)}}
      @keyframes mj-map-fade{from{opacity:0}}
      .mj-map-enter{animation:mj-map-in 300ms ${STAYS_EASE} both}
      @media (prefers-reduced-motion:reduce){.mj-map-enter{animation:mj-map-fade 160ms ease both}}
    `}</style>
  );
}
